import { SimpleGrid } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { ProfileFormField } from 'src/non-financial-data/components/ProfileFormField';
import { ProfileFormList } from 'src/non-financial-data/components/ProfileFormList';

const defaultFields = {
  type: '',
  name: '',
  phone_number: '',
  email: '',
  address: '',
};

export function ProfessionalConnectionsFields() {
  const cq = useContainerQuery();

  return (
    <ProfileFormList
      entityType="ProfessionalConnection"
      addButtonLabel="Add"
      defaultFields={defaultFields}
    >
      {index => (
        <>
          <SimpleGrid cols={cq({ base: 1, sm: 2 })}>
            <ProfileFormField
              entityType="ProfessionalConnection"
              fieldName="type"
              label="Type"
              index={index}
            />
            <ProfileFormField
              entityType="ProfessionalConnection"
              fieldName="name"
              label="Name"
              index={index}
            />
            <ProfileFormField
              entityType="ProfessionalConnection"
              fieldName="phone_number"
              index={index}
            />
            <ProfileFormField entityType="ProfessionalConnection" fieldName="email" index={index} />
          </SimpleGrid>
          <ProfileFormField entityType="ProfessionalConnection" fieldName="address" index={index} />
        </>
      )}
    </ProfileFormList>
  );
}
